<template>
    <div class="okraina-retail-ct" v-if="items.length > 0">

        <h2>Итого</h2>

        <div class="trow" v-if="discount > 0">
            <div class="label">Ваша скидка</div>
            <div class="value discount" v-html="tools.formatPrice(discount, {
        supDecimals: false,
        supCurrency: false,
    })">
            </div>
        </div>

        <div class="trow price">
            <div class="label">Сумма с учетом скидки</div>
            <template v-if="hasNoPrice">
                <div class="value">уточните у менеджера</div>
            </template>
            <template v-else>
                <div class="value"
                    v-html="tools.formatPrice(discountPrice, { supDecimals: false, supCurrency: false })">
                </div>
            </template>

        </div>

        <div class="trow sum" @click="showHowTotal">
            <div>
                <div class="label">К оплате</div>
            </div>

            <template v-if="hasNoPrice">
                <div class="value">уточните у менеджера</div>
            </template>
            <template v-else>
                <div class="value" v-html="tools.formatPrice(sum, { supDecimals: false, supCurrency: false })"></div>
            </template>


        </div>
    </div>
</template>

<script>
import tools from "@/plugins/tools";

export default {
    name: "okraina-retail-cart-total",
    data() {
        return {
            tools: tools,
        }
    },
    components: {
    },
    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
        products: {
            type: Array,
            default() {
                return [];
            },
        },
    },

    computed: {

        discountPrice() {

            let sum = 0;
            this.items.forEach(item => {

                let product = this.products.find(p => p.FIELDS.ID == item.PRODUCT_ID);
                if (product && product.PRICE) {
                    sum += item.QUANTITY * product.PRICE.DISCOUNT_VALUE;
                }

            });

            return sum;
        },

        price() {

            let sum = 0;
            this.items.forEach(item => {

                let product = this.products.find(p => p.FIELDS.ID == item.PRODUCT_ID);
                if (product && product.PRICE) {
                    sum += item.QUANTITY * product.PRICE.VALUE;
                }

            });

            return sum;
        },

        sum() {
            return this.discountPrice;
        },

        discount() {
            return this.price - this.discountPrice;
        },

        hasNoPrice() {
            return this.items.filter(item => !item.PRICE).length > 0
        }

    },

    methods: {
    }
}
</script>

<style lang="scss">
.okraina-retail-ct {
    margin-top: 25px;
    padding: 0px 16px;

    .trow {
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        margin-bottom: 10px;
    }

    .value {
        font-weight: 500;
        max-width: 140px;
        text-align: right;
    }

    .okraina-price {
        font-size: 14px;
        font-weight: 500;
    }

    .sum {
        .label {
            font-size: 18px;
            font-weight: 600;
            color: var(--color-text-dark);
        }

        .okraina-price {
            font-size: 18px;
            font-weight: 600;
        }
    }

    .discount {
        color: var(--color-discount);

        .okraina-price {
            color: var(--color-discount);
        }

    }

}
</style>